import { ENTRIES_LOADED } from '../constants';

export default function update(state = {byContentfulId:{}, all:[]}, action) {
    switch (action.type) {
        case ENTRIES_LOADED:
            if(action.entries.contrarianAd) {
                let result = {byContentfulId:{}, all:[]}
                Object.keys(action.entries.contrarianAd).forEach(k => {
                    let it = action.entries.contrarianAd[k]
                    if (it && it._id) {
                        result.byContentfulId[it._id] = it
                        result.all.push(it)
                    }
                })
                return result
            }
            break;
    }
    return state;
}
